export default __webpack_public_path__ + "static/media/log-in.3bb30dbe.svg";